import { render, staticRenderFns } from "./IcnOpportunities.vue?vue&type=template&id=dcc4eae4&"
import script from "./IcnOpportunities.vue?vue&type=script&lang=ts&"
export * from "./IcnOpportunities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports